import { ReactNode, Suspense } from 'react';
import { matchPath } from 'react-router';

import { NsxHeader } from 'components/common/nsx-header/NsxHeader';
import { AuthProvider } from 'components/common/auth-provider/AuthProvider';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { RouteScreenContext } from 'components/app/AppContext';

import type { Route } from './app-routes';

type RouteScreenProps = {
  route: Route;
  routes: Route[];
  children?: ReactNode;
  isLoginEnabled?: boolean;
};

export const RouteScreen = (props: RouteScreenProps) => {
  const {
    route: { path, hasFooter, requiresLogin, noIndex },
    route,
    routes,
    children,
    isLoginEnabled
  } = props;
  const authEnabled = requiresLogin && isLoginEnabled;
  const routeScreenContextValue = { route, routes };

  const isLoading = !matchPath(
    `${import.meta.env.VITE_PATH_PREFIX || ''}${path}`,
    window.location.pathname
  );

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <AuthProvider enabled={authEnabled}>
        <RouteScreenContext.Provider value={routeScreenContextValue}>
          <NsxHeader route={props.route} />
          <main id="#content">
            <div hidden={!isLoading}>
              <NsStopgap />
            </div>
            <div hidden={isLoading}>
              <Suspense fallback={<NsStopgap />}>{children}</Suspense>
            </div>
          </main>
          {hasFooter && <nsx-footer />}
        </RouteScreenContext.Provider>
      </AuthProvider>
    </>
  );
};
